
import config from '../nyConfig'

const ApiDic = {
    "添加字典分类": new config({url: 'manager/dic/addType', showSuccessMessage: true, useToken: true }),
    "修改字典分类": new config({url: 'manager/dic/editType', showSuccessMessage: true, useToken: true }),
    "删除字典分类": new config({url: 'manager/dic/delType', showSuccessMessage: true, useToken: true }),
    "字典分类列表": new config({url: 'manager/dic/listType', showSuccessMessage: false, useToken: true }),

    "添加字典": new config({url: 'manager/dic/addDic', showSuccessMessage: true, useToken: true }),
    "修改字典": new config({url: 'manager/dic/editDic', showSuccessMessage: true, useToken: true }),
    "删除字典": new config({url: 'manager/dic/delDic', showSuccessMessage: true, useToken: true }),
    "字典分页": new config({url: 'manager/dic/pageDic', showSuccessMessage: false, useToken: true }),
    "字典列表": new config({url: 'manager/dic/listDic', showSuccessMessage: false, useToken: true }),
    "字典列表查询": new config({url: 'manager/dic/listDicByType', showSuccessMessage: false, useToken: true }),
    "字典列表全部": new config({url: 'manager/dic/ListAllDic', showSuccessMessage: false, useToken: true }),

    "添加字典标签": new config({url: 'manager/dic/addLabel', showSuccessMessage: true, useToken: true }),
    "修改字典标签": new config({url: 'manager/dic/editLabel', showSuccessMessage: true, useToken: true }),
    "删除字典标签": new config({url: 'manager/dic/delLabel', showSuccessMessage: true, useToken: true }),
    "字典标签分页": new config({url: 'manager/dic/pageLabel', showSuccessMessage: false, useToken: true }),
    "字典标签列表": new config({url: 'manager/dic/listLabel', showSuccessMessage: false, useToken: true }),

    "标签获取字典分类": new config({url: 'manager/dic/listTypeByLabel', showSuccessMessage: false, useToken: true }),
    "标签获取所有字典": new config({url: 'manager/dic/listAllDicByLabel', showSuccessMessage: false, useToken: true })
}

export default ApiDic
